import React, { useEffect, useState, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { CardBody, Modal } from "reactstrap";
import { useNavigate } from "react-router-dom";
import CardHeader from "../../Common/CardHeader/CardHeader";
import search from "../../assets/images/search-lg.svg";
import { getCustomerMembership } from "../../../redux/cutomerMemb/action";
import CommonPagination from "../../Common/Pagination/CommonPagination";
import UserFilter from "../User/UserFilter";
import FullScreenLoader from "../../Layouts/FullScreenLoader/FullScreenLoader";
import Check from "../../assets/images/checkk.svg";
import Cross from "../../assets/images/cross.svg";
import { formatDate } from "../../Common/Utils/dateUtils";
import {
  formatPurchaseSourceLabel,
  getMembershipTermLabel,
} from "../../Common/Utils/adminViewUtils";
import "../../Common/Styles/AdminEnhancements.css";

const CustomerMemberShipList = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [modals, setModals] = useState(false);
  const customerMembershipList = useSelector(
    (state) => state?.reusableSlice?.customerMembershipList
  );
  const [params, setParams] = useState({
    page: 1,
    search_key: "",
    status: "",
    type: 1,
    start_data: "",
    end_date: "",
    user_id: "",
  });

  const addComponent = () => {
    navigate("/addcustomermembership");
  };

  useEffect(() => {
    dispatch(getCustomerMembership(params))
      .then(() => {
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, [dispatch, params]);

  const memberships = customerMembershipList?.memberships || [];

  const summary = useMemo(() => {
    const sources = memberships.reduce((acc, item) => {
      const label = formatPurchaseSourceLabel(item?.purchase_source_label);
      acc[label] = (acc[label] || 0) + 1;
      return acc;
    }, {});

    return [
      {
        label: "Visible memberships",
        value: memberships.length,
        subtext: customerMembershipList?.pagination_meta?.total
          ? `${customerMembershipList.pagination_meta.total} total records`
          : "Current page view",
      },
      {
        label: "Reported enabled",
        value: memberships.filter((item) => item?.zatca_status === "REPORTED").length,
        subtext: "ZATCA reported",
      },
      {
        label: "Signed XML",
        value: memberships.filter((item) => item?.signed_xml_url).length,
        subtext: "Has signed XML",
      },
      {
        label: "Top source",
        value: Object.entries(sources).sort((a, b) => b[1] - a[1])[0]?.[0] || "--",
        subtext: "Most common purchase channel on this page",
      },
    ];
  }, [memberships, customerMembershipList]);

  return (
    <>
      {loading ? (
        <FullScreenLoader />
      ) : (
        <div>
          <Modal isOpen={modals} toggle={() => setModals(!modals)}>
            <UserFilter
              modal={modals}
              setModal={setModals}
              params={params}
              setParams={setParams}
            />
          </Modal>
          <CardHeader
            headerTitle="Customer with Membership"
            params={params}
            setParams={setParams}
            addmodel={addComponent}
            search={search}
            modals={modals}
            setModals={setModals}
          />
          <div className="px-3">
            <div className="admin-summary-grid">
              {summary.map((item) => (
                <div className="admin-summary-card" key={item.label}>
                  <div className="admin-summary-label">{item.label}</div>
                  <div className="admin-summary-value">{item.value}</div>
                  <div className="admin-summary-subtext">{item.subtext}</div>
                </div>
              ))}
            </div>
          </div>
          <CardBody className="table-sec px-3">
            <table className="table border-table-sec">
              <thead>
                <tr>
                  <th scope="col">#</th>
                  <th scope="col">Customer</th>
                  <th scope="col">Title</th>
                  <th scope="col">Term</th>
                  <th scope="col">Source</th>
                  <th scope="col" colSpan="2" className="text-center">
                    Simplified
                  </th>
                  <th scope="col" colSpan="2" className="text-center">
                    VAT
                  </th>
                  <th scope="col" colSpan="2" className="text-center">
                    Purchase
                  </th>
                  <th scope="col">Reported</th>
                  <th scope="col">Signed</th>
                  <th scope="col">Start Date</th>
                  <th scope="col">End Date</th>
                </tr>

                <tr>
                  <th colSpan="5"></th>
                  <th>Total</th>
                  <th>Left</th>
                  <th>Total</th>
                  <th>Left</th>
                  <th>Total</th>
                  <th>Left</th>
                  <th colSpan="4"></th>
                </tr>
              </thead>
              <tbody>
                {memberships.length > 0 ? (
                  memberships.map((item, index) => (
                    <tr key={item?.id || index}>
                      <td>{index + 1 + (params?.page - 1) * 10}</td>
                      <td>
                        <div>{`${item?.user_firstname} ${item?.user_lastname}`}</div>
                        <div className="admin-inline-note">{item?.company_name || "--"}</div>
                      </td>
                      <td>{item?.membership_title}</td>
                      <td>
                        <span className="admin-chip admin-chip--info">
                          {getMembershipTermLabel(item)}
                        </span>
                      </td>
                      <td>
                        <span className="admin-chip">{formatPurchaseSourceLabel(item?.purchase_source_label)}</span>
                      </td>
                      <td>
                        {item?.max_invoices == "10000"
                          ? "Unlimited"
                          : item?.max_invoices}
                      </td>
                      <td>
                        {item?.invoice_left == "10000"
                          ? "Unlimited"
                          : item?.invoice_left}
                      </td>
                      <td>
                        {item?.max_invoices1 == "10000"
                          ? "Unlimited"
                          : item?.max_invoices1}
                      </td>
                      <td>
                        {item?.invoice_left1 == "10000"
                          ? "Unlimited"
                          : item?.invoice_left1}
                      </td>
                      <td>
                        {item?.max_invoices2 == "10000"
                          ? "Unlimited"
                          : item?.max_invoices2}
                      </td>
                      <td>
                        {item?.invoice_left2 == "10000"
                          ? "Unlimited"
                          : item?.invoice_left2}
                      </td>
                      <td>
                        {item?.onboarding === 0 ? (
                          <h5>--</h5>
                        ) : (
                          <img
                            src={item?.zatca_status == "REPORTED" ? Check : Cross}
                            alt="reported status"
                          />
                        )}
                      </td>
                      <td>
                        {item?.onboarding === 0 ? (
                          <h5>--</h5>
                        ) : (
                          <img src={item?.signed_xml_url ? Check : Cross} alt="signed xml" />
                        )}
                      </td>

                      <td>{formatDate(item?.start_date)}</td>
                      <td>{formatDate(item?.end_date)}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="15" className="text-center">
                      No membership Found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </CardBody>

          <CommonPagination
            params={params}
            setParams={setParams}
            pagination_meta={customerMembershipList?.pagination_meta}
          />
        </div>
      )}
    </>
  );
};

export default CustomerMemberShipList;
